import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i2 from 'base-print-petition-library';
import { BasePrintPetitionLibraryService } from 'base-print-petition-library';
import { environment } from 'environment-configurations';
import * as i1 from '@ngrx/store';
import * as i3 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from '@angular/material/dialog';
import * as i6 from '@angular/forms';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import * as i7 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i8 from 'maximize-dialog-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import * as i9 from 'step-status-update-component-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import * as i10 from 'assigning-task-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import * as i11 from 'primeng/divider';
import * as i12 from 'last-update-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import * as i13 from 'primeng/tabview';
import * as i14 from 'primeng/dropdown';
import * as i15 from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import * as i16 from 'primeng/tooltip';
import * as i17 from 'primeng/radiobutton';
import * as i18 from 'primeng/fileupload';
import * as i19 from 'file-download-library';
import { FileDownloadLibraryModule } from 'file-download-library';
import * as i20 from 'primeng/dialog';
import * as i21 from 'primeng/chips';
import * as i22 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i23 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i24 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i25 from '@progress/kendo-angular-editor';
import { EditorModule } from '@progress/kendo-angular-editor';
import * as i26 from '@progress/kendo-angular-toolbar';
import * as i27 from 'editor-library';
import { EditorLibraryModule } from 'editor-library';
import * as i28 from '@angular/material/core';
import * as i29 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i30 from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { PrimengLibraryModule } from 'primeng-library';
import { DateFormatModule } from 'date-format';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ToastModule } from 'primeng/toast';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { FileUploadLibraryModule } from 'file-upload-library';
import { ngfModule } from 'angular-file';

class PrintPetitionLibraryService {
    constructor() { }
}
PrintPetitionLibraryService.ɵfac = function PrintPetitionLibraryService_Factory(t) { return new (t || PrintPetitionLibraryService)(); };
PrintPetitionLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: PrintPetitionLibraryService, factory: PrintPetitionLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PrintPetitionLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function PrintPetitionLibraryComponent_ng_container_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵelementStart(2, "h2");
    i0.ɵɵtext(3, "Signatures & Generate Final");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p");
    i0.ɵɵtext(5, "Insert Signature");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function PrintPetitionLibraryComponent_ng_container_1_div_1_lib_step_status_update_component_library_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-step-status-update-component-library", 19);
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("visaType", ctx_r11.inputData.caseType != "I130" ? ctx_r11.inputData.visatype : ctx_r11.inputData.caseType)("stepDetails", ctx_r11.stepDetails)("isViewMode", ctx_r11.inputData["isViewMode"])("isCaseRequest", ctx_r11.inputData["isCaseRequest"]);
} }
const _c0 = function (a0) { return { "layoutCode": a0 }; };
function PrintPetitionLibraryComponent_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, PrintPetitionLibraryComponent_ng_container_1_div_1_div_1_Template, 6, 0, "div", 11);
    i0.ɵɵelementStart(2, "div", 12);
    i0.ɵɵtemplate(3, PrintPetitionLibraryComponent_ng_container_1_div_1_lib_step_status_update_component_library_3_Template, 1, 4, "lib-step-status-update-component-library", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 14);
    i0.ɵɵelement(5, "lib-maximize-dialog-library", 15);
    i0.ɵɵelementStart(6, "i", 16);
    i0.ɵɵlistener("click", function PrintPetitionLibraryComponent_ng_container_1_div_1_Template_i_click_6_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r9.isWizard);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r9.isWizard);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("configData", i0.ɵɵpureFunction1(3, _c0, ctx_r9.inputData == null ? null : ctx_r9.inputData.layoutCode));
} }
function PrintPetitionLibraryComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PrintPetitionLibraryComponent_ng_container_1_div_1_Template, 7, 5, "div", 9);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isSimplifyH1b ? false : true);
} }
function PrintPetitionLibraryComponent_div_2_lib_step_status_update_component_library_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-step-status-update-component-library", 27);
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("visaType", ctx_r14.inputData.caseType != "I130" ? ctx_r14.inputData.visatype : ctx_r14.inputData.caseType)("stepDetails", ctx_r14.stepDetails)("isViewMode", ctx_r14.inputData["isViewMode"])("isCaseRequest", ctx_r14.inputData["isCaseRequest"]);
} }
function PrintPetitionLibraryComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "div", 21);
    i0.ɵɵelementStart(2, "div", 22);
    i0.ɵɵelementStart(3, "h2");
    i0.ɵɵtext(4, "Signatures & Generate Final");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6, "Insert Signature");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 23);
    i0.ɵɵelementStart(8, "ul");
    i0.ɵɵelementStart(9, "li", 24);
    i0.ɵɵtemplate(10, PrintPetitionLibraryComponent_div_2_lib_step_status_update_component_library_10_Template, 1, 4, "lib-step-status-update-component-library", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "li", 26);
    i0.ɵɵelement(12, "lib-maximize-dialog-library", 15);
    i0.ɵɵelementStart(13, "i", 16);
    i0.ɵɵlistener("click", function PrintPetitionLibraryComponent_div_2_Template_i_click_13_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngIf", !ctx_r1.isWizard);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("configData", i0.ɵɵpureFunction1(2, _c0, ctx_r1.inputData == null ? null : ctx_r1.inputData.layoutCode));
} }
function PrintPetitionLibraryComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵelementStart(2, "lib-assigning-task-library", 30);
    i0.ɵɵlistener("updateStatus", function PrintPetitionLibraryComponent_div_3_Template_lib_assigning_task_library_updateStatus_2_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.updateStepStatus($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("visaType", ctx_r2.inputData.visatype)("stepDetails", ctx_r2.stepDetails)("isViewMode", ctx_r2.inputData["isViewMode"])("isCaseRequest", ctx_r2.inputData["isCaseRequest"]);
} }
function PrintPetitionLibraryComponent_p_divider_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider", 31);
} }
function PrintPetitionLibraryComponent_lib_last_update_library_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-last-update-library", 32);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("inputDetails", ctx_r4.stepDetails)("primaryData", ctx_r4.inputData)("sectionCode", ctx_r4.sectionCode);
} }
function PrintPetitionLibraryComponent_div_7_div_19_div_5_i_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 72);
} }
const _c1 = function (a0, a1) { return { "avalible mb-0": a0, "notAvalible mb-0": a1 }; };
function PrintPetitionLibraryComponent_div_7_div_19_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵelementStart(1, "div", 68);
    i0.ɵɵelementStart(2, "input", 69);
    i0.ɵɵlistener("change", function PrintPetitionLibraryComponent_div_7_div_19_div_5_Template_input_change_2_listener($event) { i0.ɵɵrestoreView(_r37); const i_r34 = ctx.index; const ctx_r36 = i0.ɵɵnextContext(3); return ctx_r36.toggleVisibility($event, i_r34); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 70);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "label", 33);
    i0.ɵɵtemplate(6, PrintPetitionLibraryComponent_div_7_div_19_div_5_i_6_Template, 1, 0, "i", 71);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r33 = ctx.$implicit;
    const i_r34 = ctx.index;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControlName", i_r34);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("for", item_r33.label);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r33.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c1, (item_r33 == null ? null : item_r33.signatureAvalible) == true, (item_r33 == null ? null : item_r33.signatureAvalible) == false));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(item_r33 == null ? null : item_r33.signatureAvalible));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (item_r33 == null ? null : item_r33.signatureAvalible) ? "Signature is Available" : "Signature is Not Available", "");
} }
function PrintPetitionLibraryComponent_div_7_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "div", 43);
    i0.ɵɵelementStart(2, "h6");
    i0.ɵɵelementStart(3, "b");
    i0.ɵɵtext(4, "Select signatories who will sign the forms");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, PrintPetitionLibraryComponent_div_7_div_19_div_5_Template, 8, 9, "div", 64);
    i0.ɵɵelementStart(6, "div", 65);
    i0.ɵɵelement(7, "button", 66);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r19.signatureInfo);
} }
function PrintPetitionLibraryComponent_div_7_div_20_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵelementStart(1, "div", 68);
    i0.ɵɵelementStart(2, "input", 69);
    i0.ɵɵlistener("change", function PrintPetitionLibraryComponent_div_7_div_20_div_18_Template_input_change_2_listener($event) { i0.ɵɵrestoreView(_r42); const j_r40 = ctx.index; const ctx_r41 = i0.ɵɵnextContext(3); return ctx_r41.toggleSignatoryVisibility($event, j_r40); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 70);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r39 = ctx.$implicit;
    const j_r40 = ctx.index;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControlName", j_r40);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("for", item_r39.label);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r39.label);
} }
function PrintPetitionLibraryComponent_div_7_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 28);
    i0.ɵɵelementStart(2, "div", 73);
    i0.ɵɵelementStart(3, "ul", 74);
    i0.ɵɵelementStart(4, "li", 75);
    i0.ɵɵelementStart(5, "div", 76);
    i0.ɵɵtext(6, "1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "li", 75);
    i0.ɵɵelementStart(8, "div", 76);
    i0.ɵɵtext(9, "2");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 77);
    i0.ɵɵelementStart(11, "div", 28);
    i0.ɵɵelementStart(12, "div", 78);
    i0.ɵɵelementStart(13, "div", 43);
    i0.ɵɵelementStart(14, "h6");
    i0.ɵɵelementStart(15, "b");
    i0.ɵɵtext(16, "Select signatories who will sign the forms");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "form", 79);
    i0.ɵɵtemplate(18, PrintPetitionLibraryComponent_div_7_div_20_div_18_Template, 5, 3, "div", 64);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 78);
    i0.ɵɵelementStart(20, "div", 80);
    i0.ɵɵelement(21, "i", 81);
    i0.ɵɵelementStart(22, "label");
    i0.ɵɵtext(23, " To sign the form manually, you need to email the signatories with instructions to download the form. After signing it, they should either upload it back to the Imagility system or courier the form. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 82);
    i0.ɵɵelementStart(25, "div", 83);
    i0.ɵɵelementStart(26, "div", 43);
    i0.ɵɵelementStart(27, "h6");
    i0.ɵɵelementStart(28, "b");
    i0.ɵɵtext(29, "How do you want the signatories to return the signed forms");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 84);
    i0.ɵɵelementStart(31, "div", 85);
    i0.ɵɵelementStart(32, "p-radioButton", 86);
    i0.ɵɵlistener("ngModelChange", function PrintPetitionLibraryComponent_div_7_div_20_Template_p_radioButton_ngModelChange_32_listener($event) { i0.ɵɵrestoreView(_r44); const ctx_r43 = i0.ɵɵnextContext(2); return ctx_r43.returnForms = $event; })("onClick", function PrintPetitionLibraryComponent_div_7_div_20_Template_p_radioButton_onClick_32_listener() { i0.ɵɵrestoreView(_r44); const ctx_r45 = i0.ɵɵnextContext(2); return ctx_r45.onReturnForms("type3"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "label");
    i0.ɵɵtext(34, "By Delivery Service");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "div", 87);
    i0.ɵɵelementStart(36, "p-radioButton", 88);
    i0.ɵɵlistener("ngModelChange", function PrintPetitionLibraryComponent_div_7_div_20_Template_p_radioButton_ngModelChange_36_listener($event) { i0.ɵɵrestoreView(_r44); const ctx_r46 = i0.ɵɵnextContext(2); return ctx_r46.returnForms = $event; })("onClick", function PrintPetitionLibraryComponent_div_7_div_20_Template_p_radioButton_onClick_36_listener() { i0.ɵɵrestoreView(_r44); const ctx_r47 = i0.ɵɵnextContext(2); return ctx_r47.onReturnForms("type4"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "label");
    i0.ɵɵtext(38, "Sign and Upload Forms");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(17);
    i0.ɵɵproperty("formGroup", ctx_r20.signatoriesSignedForm);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r20.selectedSignatory);
    i0.ɵɵadvance(14);
    i0.ɵɵproperty("ngModel", ctx_r20.returnForms);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r20.returnForms);
} }
function PrintPetitionLibraryComponent_div_7_h5_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 89);
    i0.ɵɵtext(1, "Select single or multiple and click on the generate signature button.");
    i0.ɵɵelementEnd();
} }
function PrintPetitionLibraryComponent_div_7_h5_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5");
    i0.ɵɵtext(1, "Select forms that you want to send for signature");
    i0.ɵɵelementEnd();
} }
function PrintPetitionLibraryComponent_div_7_button_27_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 90);
    i0.ɵɵlistener("click", function PrintPetitionLibraryComponent_div_7_button_27_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r49); const ctx_r48 = i0.ɵɵnextContext(2); return ctx_r48.onClickEmail(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r23.checkedList && ctx_r23.checkedList.length == 0 ? true : false);
} }
function PrintPetitionLibraryComponent_div_7_button_28_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 91);
    i0.ɵɵlistener("click", function PrintPetitionLibraryComponent_div_7_button_28_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r51); const ctx_r50 = i0.ɵɵnextContext(2); return ctx_r50.onClickEmail(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r24.checkedList && ctx_r24.checkedList.length == 0 ? true : false);
} }
function PrintPetitionLibraryComponent_div_7_button_29_Template(rf, ctx) { if (rf & 1) {
    const _r53 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 92);
    i0.ɵɵlistener("click", function PrintPetitionLibraryComponent_div_7_button_29_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r53); const ctx_r52 = i0.ɵɵnextContext(2); return ctx_r52.postGenerateDoc(ctx_r52.checkedList, 2); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", !ctx_r25.signatureInfoAvailable ? true : ctx_r25.checkedList && ctx_r25.checkedList.length == 0 ? true : !ctx_r25.currentSelect ? true : false);
} }
function PrintPetitionLibraryComponent_div_7_input_36_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 93);
    i0.ɵɵlistener("ngModelChange", function PrintPetitionLibraryComponent_div_7_input_36_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r55); const ctx_r54 = i0.ɵɵnextContext(2); return ctx_r54.masterSelected = $event; })("change", function PrintPetitionLibraryComponent_div_7_input_36_Template_input_change_0_listener() { i0.ɵɵrestoreView(_r55); const ctx_r56 = i0.ɵɵnextContext(2); return ctx_r56.checkUncheckAll(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngModel", ctx_r26.masterSelected);
} }
function PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_label_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r58 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r58.signatorList);
} }
function PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_td_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "td");
} }
function PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_td_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r58 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassProp("successInfo", item_r58.docGenerated === 1)("warnInfo", item_r58.docGenerated !== 1);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r58.docGenerated === 1 ? "Form Generated" : "Form Not Generated", " ");
} }
function PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_td_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r58 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassProp("successInfo", item_r58.docUploaded === 1)("warnInfo", item_r58.docUploaded !== 1);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r58.docUploaded === 1 ? "File Uploaded" : item_r58.docUploaded === 2 ? "Email Sent" : "File Not Uploaded", " ");
} }
function PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_p_17_Template(rf, ctx) { if (rf & 1) {
    const _r73 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 101);
    i0.ɵɵlistener("click", function PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_p_17_Template_p_click_0_listener() { i0.ɵɵrestoreView(_r73); const item_r58 = i0.ɵɵnextContext().$implicit; const ctx_r71 = i0.ɵɵnextContext(3); return ctx_r71.onClickGenerateForm(item_r58.pbSupportDocumentId); });
    i0.ɵɵtext(1, "Generate");
    i0.ɵɵelementEnd();
} }
function PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_p_20_Template(rf, ctx) { if (rf & 1) {
    const _r76 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 101);
    i0.ɵɵlistener("click", function PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_p_20_Template_p_click_0_listener() { i0.ɵɵrestoreView(_r76); const item_r58 = i0.ɵɵnextContext().$implicit; const ctx_r74 = i0.ɵɵnextContext(3); return ctx_r74.onIndividualMail(item_r58); });
    i0.ɵɵtext(1, "Resend Email");
    i0.ɵɵelementEnd();
} }
function PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_p_21_Template(rf, ctx) { if (rf & 1) {
    const _r79 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵelementStart(1, "p-fileUpload", 102, 103);
    i0.ɵɵlistener("uploadHandler", function PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_p_21_Template_p_fileUpload_uploadHandler_1_listener($event) { i0.ɵɵrestoreView(_r79); const _r77 = i0.ɵɵreference(2); const item_r58 = i0.ɵɵnextContext().$implicit; const ctx_r78 = i0.ɵɵnextContext(3); return ctx_r78.onUploadHandle($event, _r77, item_r58.pbSupportDocumentId, item_r58.formCode); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r66 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("accept", ctx_r66.acceptedTypes)("auto", true);
} }
function PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_p_22_Template(rf, ctx) { if (rf & 1) {
    const _r83 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 101);
    i0.ɵɵlistener("click", function PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_p_22_Template_p_click_0_listener() { i0.ɵɵrestoreView(_r83); const item_r58 = i0.ɵɵnextContext().$implicit; const ctx_r81 = i0.ɵɵnextContext(3); return ctx_r81.download(item_r58.fileLocation); });
    i0.ɵɵtext(1, "Download Form");
    i0.ɵɵelementEnd();
} }
function PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r86 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "input", 95);
    i0.ɵɵlistener("ngModelChange", function PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_Template_input_ngModelChange_2_listener($event) { const item_r58 = ctx.$implicit; return item_r58.isSelected = $event; })("change", function PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_Template_input_change_2_listener() { i0.ɵɵrestoreView(_r86); const ctx_r85 = i0.ɵɵnextContext(3); return ctx_r85.isAllSelected(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtemplate(8, PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_label_8_Template, 2, 1, "label", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_td_11_Template, 1, 0, "td", 1);
    i0.ɵɵtemplate(12, PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_td_12_Template, 2, 5, "td", 96);
    i0.ɵɵtemplate(13, PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_td_13_Template, 2, 5, "td", 96);
    i0.ɵɵelementStart(14, "td", 97);
    i0.ɵɵelementStart(15, "p-button", 98);
    i0.ɵɵlistener("click", function PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_Template_p_button_click_15_listener($event) { i0.ɵɵrestoreView(_r86); const item_r58 = ctx.$implicit; const i_r59 = ctx.index; const ctx_r87 = i0.ɵɵnextContext(3); return ctx_r87.toggleMenu(item_r58, i_r59, $event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 99);
    i0.ɵɵtemplate(17, PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_p_17_Template, 2, 0, "p", 100);
    i0.ɵɵelementStart(18, "p", 101);
    i0.ɵɵlistener("click", function PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_Template_p_click_18_listener() { i0.ɵɵrestoreView(_r86); const item_r58 = ctx.$implicit; const ctx_r88 = i0.ɵɵnextContext(3); return ctx_r88.viewPetition(item_r58.fileLocation); });
    i0.ɵɵtext(19, "View Form");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(20, PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_p_20_Template, 2, 0, "p", 100);
    i0.ɵɵtemplate(21, PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_p_21_Template, 3, 2, "p", 1);
    i0.ɵɵtemplate(22, PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_p_22_Template, 2, 0, "p", 100);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r58 = ctx.$implicit;
    const i_r59 = ctx.index;
    const ctx_r57 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", item_r58.id);
    i0.ɵɵproperty("ngModel", item_r58.isSelected);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r58.formType);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r58 == null ? null : item_r58.signatureType);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r58 == null ? null : item_r58.signatorList);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r58.returnType == "" ? "--" : item_r58.returnType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r58.signatureType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r58.signatureType === "Image Sign Type");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r58.signatureType === "Manual Sign Type");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("hidden", !(ctx_r57.isMenuVisible && ctx_r57.currentItem == i_r59));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r57.signatureType === "Signature1" && !(!ctx_r57.signatureInfoAvailable ? true : ctx_r57.checkedList && ctx_r57.checkedList.length == 0 ? true : !ctx_r57.currentSelect ? true : false));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r57.signatureType === "Signature2" && item_r58.id);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r57.signatureType === "Signature2" && ctx_r57.returnForms == "type3" && (item_r58.returnType == "Delivery Service" || !item_r58.returnType));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r57.signatureType === "Signature2" && item_r58.docUploaded == 1);
} }
function PrintPetitionLibraryComponent_div_7_tbody_49_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, PrintPetitionLibraryComponent_div_7_tbody_49_tr_1_Template, 23, 14, "tr", 94);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r27.listDocuments);
} }
function PrintPetitionLibraryComponent_div_7_div_50_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 104);
    i0.ɵɵelementStart(1, "span", 105);
    i0.ɵɵtext(2, "No Data");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function PrintPetitionLibraryComponent_div_7_div_52_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 106);
    i0.ɵɵelementStart(1, "div", 107);
    i0.ɵɵelementStart(2, "h6", 108);
    i0.ɵɵtext(3, "Click on the \u2018Generate\u2019 to view/ download the complete Petition PDF");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function PrintPetitionLibraryComponent_div_7_div_53_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 117);
    i0.ɵɵelementStart(1, "p", 118);
    i0.ɵɵtext(2, "Generated");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p", 119);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r89 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r89.draftGeneratedDate);
} }
function PrintPetitionLibraryComponent_div_7_div_53_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 117);
    i0.ɵɵelementStart(1, "p", 120);
    i0.ɵɵtext(2, "Not Generated");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function PrintPetitionLibraryComponent_div_7_div_53_i_7_Template(rf, ctx) { if (rf & 1) {
    const _r94 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 121);
    i0.ɵɵlistener("click", function PrintPetitionLibraryComponent_div_7_div_53_i_7_Template_i_click_0_listener() { i0.ɵɵrestoreView(_r94); const ctx_r93 = i0.ɵɵnextContext(3); return ctx_r93.viewPetition(ctx_r93.fullPDFPath); });
    i0.ɵɵelementEnd();
} }
function PrintPetitionLibraryComponent_div_7_div_53_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 122);
    i0.ɵɵelement(1, "file-download-library", 123);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r92 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fileName", ctx_r92.fullPDFPath)("Path", ctx_r92.envPath + ctx_r92.fullPDFPath.substring(23));
} }
function PrintPetitionLibraryComponent_div_7_div_53_Template(rf, ctx) { if (rf & 1) {
    const _r96 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 109);
    i0.ɵɵelementStart(1, "div", 110);
    i0.ɵɵelementStart(2, "label", 111);
    i0.ɵɵtext(3, "Generate Full Petition");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PrintPetitionLibraryComponent_div_7_div_53_div_4_Template, 5, 1, "div", 112);
    i0.ɵɵtemplate(5, PrintPetitionLibraryComponent_div_7_div_53_div_5_Template, 3, 0, "div", 112);
    i0.ɵɵelementStart(6, "div", 113);
    i0.ɵɵtemplate(7, PrintPetitionLibraryComponent_div_7_div_53_i_7_Template, 1, 0, "i", 114);
    i0.ɵɵtemplate(8, PrintPetitionLibraryComponent_div_7_div_53_div_8_Template, 2, 2, "div", 115);
    i0.ɵɵelementStart(9, "i", 116);
    i0.ɵɵlistener("click", function PrintPetitionLibraryComponent_div_7_div_53_Template_i_click_9_listener() { i0.ɵɵrestoreView(_r96); const ctx_r95 = i0.ɵɵnextContext(2); return ctx_r95.generatePetition(false); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r30.enableViewDraftButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r30.enableViewDraftButton);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r30.enableViewDraftButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r30.enableViewDraftButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r30.disabledControls ? "notAllowed" : "");
} }
function PrintPetitionLibraryComponent_div_7_div_54_lib_step_status_update_component_library_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-step-status-update-component-library", 128);
} if (rf & 2) {
    const ctx_r97 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("visaType", ctx_r97.inputData.caseType != "I130" ? ctx_r97.inputData.visatype : ctx_r97.inputData.caseType)("stepDetails", ctx_r97.stepDetails)("type", ctx_r97.typeOfButton)("showPreviousStepBtn", true)("showNextStepBtn", true);
} }
function PrintPetitionLibraryComponent_div_7_div_54_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 124);
    i0.ɵɵelement(1, "div", 125);
    i0.ɵɵelementStart(2, "div", 126);
    i0.ɵɵtemplate(3, PrintPetitionLibraryComponent_div_7_div_54_lib_step_status_update_component_library_3_Template, 1, 5, "lib-step-status-update-component-library", 127);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r31.isWizard);
} }
function PrintPetitionLibraryComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r99 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelementStart(1, "p-tabView", 34);
    i0.ɵɵelementStart(2, "p-tabPanel", 35);
    i0.ɵɵelementStart(3, "div", 36);
    i0.ɵɵelementStart(4, "div", 37);
    i0.ɵɵelementStart(5, "div", 38);
    i0.ɵɵelementStart(6, "div", 28);
    i0.ɵɵelementStart(7, "div", 39);
    i0.ɵɵelementStart(8, "div", 40);
    i0.ɵɵelementStart(9, "div", 41);
    i0.ɵɵelementStart(10, "p", 42);
    i0.ɵɵtext(11, "Choose a ");
    i0.ɵɵelementStart(12, "b");
    i0.ɵɵtext(13, "Signature Type");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(14, " and select the applicable forms.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 43);
    i0.ɵɵelementStart(16, "div", 44);
    i0.ɵɵelementStart(17, "p-dropdown", 45);
    i0.ɵɵlistener("ngModelChange", function PrintPetitionLibraryComponent_div_7_Template_p_dropdown_ngModelChange_17_listener($event) { i0.ɵɵrestoreView(_r99); const ctx_r98 = i0.ɵɵnextContext(); return ctx_r98.signatureType = $event; })("onChange", function PrintPetitionLibraryComponent_div_7_Template_p_dropdown_onChange_17_listener($event) { i0.ɵɵrestoreView(_r99); const ctx_r100 = i0.ɵɵnextContext(); return ctx_r100.onChangeSignature($event.value); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "form", 46);
    i0.ɵɵlistener("ngSubmit", function PrintPetitionLibraryComponent_div_7_Template_form_ngSubmit_18_listener() { i0.ɵɵrestoreView(_r99); const ctx_r101 = i0.ɵɵnextContext(); return ctx_r101.onSignatureSubmit(); });
    i0.ɵɵtemplate(19, PrintPetitionLibraryComponent_div_7_div_19_Template, 8, 1, "div", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(20, PrintPetitionLibraryComponent_div_7_div_20_Template, 39, 4, "div", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 47);
    i0.ɵɵelementStart(22, "div", 48);
    i0.ɵɵelementStart(23, "div", 49);
    i0.ɵɵtemplate(24, PrintPetitionLibraryComponent_div_7_h5_24_Template, 2, 0, "h5", 50);
    i0.ɵɵtemplate(25, PrintPetitionLibraryComponent_div_7_h5_25_Template, 2, 0, "h5", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 51);
    i0.ɵɵtemplate(27, PrintPetitionLibraryComponent_div_7_button_27_Template, 1, 1, "button", 52);
    i0.ɵɵtemplate(28, PrintPetitionLibraryComponent_div_7_button_28_Template, 1, 1, "button", 53);
    i0.ɵɵtemplate(29, PrintPetitionLibraryComponent_div_7_button_29_Template, 1, 1, "button", 54);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 55);
    i0.ɵɵelementStart(31, "div", 56);
    i0.ɵɵelementStart(32, "table", 57);
    i0.ɵɵelementStart(33, "thead");
    i0.ɵɵelementStart(34, "tr");
    i0.ɵɵelementStart(35, "th");
    i0.ɵɵtemplate(36, PrintPetitionLibraryComponent_div_7_input_36_Template, 1, 1, "input", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "th");
    i0.ɵɵtext(38, "Form Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "th");
    i0.ɵɵtext(40, "Signature Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(41, "th");
    i0.ɵɵtext(42, "Signatories");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(43, "th");
    i0.ɵɵtext(44, "Return Method");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(45, "th");
    i0.ɵɵtext(46, "Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(47, "th");
    i0.ɵɵtext(48, "Actions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(49, PrintPetitionLibraryComponent_div_7_tbody_49_Template, 2, 1, "tbody", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(50, PrintPetitionLibraryComponent_div_7_div_50_Template, 3, 0, "div", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(51, "p-tabPanel", 60);
    i0.ɵɵtemplate(52, PrintPetitionLibraryComponent_div_7_div_52_Template, 4, 0, "div", 61);
    i0.ɵɵtemplate(53, PrintPetitionLibraryComponent_div_7_div_53_Template, 10, 5, "div", 62);
    i0.ɵɵtemplate(54, PrintPetitionLibraryComponent_div_7_div_54_Template, 4, 1, "div", 63);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r5.isWizard ? "col-12 printPetition" : "col-12");
    i0.ɵɵadvance(17);
    i0.ɵɵproperty("options", ctx_r5.signatureTypeList)("ngModel", ctx_r5.signatureType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r5.additionalCoversForm);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.signatureType === "Signature1");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.signatureType === "Signature2");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r5.signatureType === "Signature1");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.signatureType === "Signature2");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.isMailSent && ctx_r5.signatureType == "Signature2" && (ctx_r5.listDocuments && ctx_r5.listDocuments.length !== 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r5.isMailSent && ctx_r5.signatureType == "Signature2" && (ctx_r5.listDocuments && ctx_r5.listDocuments.length !== 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.signatureType === "Signature1" && (ctx_r5.listDocuments && ctx_r5.listDocuments.length !== 0));
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngIf", ctx_r5.listDocuments && ctx_r5.listDocuments.length !== 0);
    i0.ɵɵadvance(13);
    i0.ɵɵproperty("ngIf", (ctx_r5.signatureType === "Signature1" || ctx_r5.signatureType === "Signature2") && (ctx_r5.listDocuments && ctx_r5.listDocuments.length !== 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r5.signatureType === "Signature1" || ctx_r5.signatureType === "Signature2") && (ctx_r5.listDocuments && ctx_r5.listDocuments.length == 0));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r5.isWizard || ctx_r5.isWizard);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r5.isWizard || ctx_r5.isWizard);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r5.isWizard);
} }
function PrintPetitionLibraryComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 129);
} }
function PrintPetitionLibraryComponent_div_9_div_16_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 199);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r112 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r112.getGlobalErrorMessages("REQUIRED"), " ");
} }
function PrintPetitionLibraryComponent_div_9_div_16_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 199);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r113 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r113.getGlobalErrorMessages("INVALID_EMAIL"), " ");
} }
function PrintPetitionLibraryComponent_div_9_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PrintPetitionLibraryComponent_div_9_div_16_span_1_Template, 2, 1, "span", 198);
    i0.ɵɵtemplate(2, PrintPetitionLibraryComponent_div_9_div_16_span_2_Template, 2, 1, "span", 198);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r102 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r102.definedtemplate.get("fromEmailids").errors == null ? null : ctx_r102.definedtemplate.get("fromEmailids").errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r102.definedtemplate.get("fromEmailids").errors == null ? null : ctx_r102.definedtemplate.get("fromEmailids").errors.pattern);
} }
function PrintPetitionLibraryComponent_div_9_div_21_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 199);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r114 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r114.getGlobalErrorMessages("REQUIRED"), " ");
} }
function PrintPetitionLibraryComponent_div_9_div_21_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 199);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r115 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r115.getGlobalErrorMessages("INVALID_EMAIL"), " ");
} }
function PrintPetitionLibraryComponent_div_9_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PrintPetitionLibraryComponent_div_9_div_21_span_1_Template, 2, 1, "span", 198);
    i0.ɵɵtemplate(2, PrintPetitionLibraryComponent_div_9_div_21_span_2_Template, 2, 1, "span", 198);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r103 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r103.definedtemplate.get("toEmailids").errors == null ? null : ctx_r103.definedtemplate.get("toEmailids").errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r103.definedtemplate.get("toEmailids").errors == null ? null : ctx_r103.definedtemplate.get("toEmailids").errors.pattern);
} }
function PrintPetitionLibraryComponent_div_9_div_26_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 199);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r116 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r116.getGlobalErrorMessages("INVALID_EMAIL"), " ");
} }
function PrintPetitionLibraryComponent_div_9_div_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PrintPetitionLibraryComponent_div_9_div_26_span_1_Template, 2, 1, "span", 198);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r104 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r104.definedtemplate.get("ccEmailids").errors == null ? null : ctx_r104.definedtemplate.get("ccEmailids").errors.pattern);
} }
function PrintPetitionLibraryComponent_div_9_div_32_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 199);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r117 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r117.getGlobalErrorMessages("REQUIRED"), " ");
} }
function PrintPetitionLibraryComponent_div_9_div_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PrintPetitionLibraryComponent_div_9_div_32_span_1_Template, 2, 1, "span", 198);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r105 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r105.definedtemplate.get("subject").errors == null ? null : ctx_r105.definedtemplate.get("subject").errors.required);
} }
function PrintPetitionLibraryComponent_div_9_mat_option_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 200);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r118 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r118.pbSupportDocumentId);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r118.formType);
} }
function PrintPetitionLibraryComponent_div_9_mat_chip_41_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 203);
    i0.ɵɵtext(1, "cancel");
    i0.ɵɵelementEnd();
} }
function PrintPetitionLibraryComponent_div_9_mat_chip_41_Template(rf, ctx) { if (rf & 1) {
    const _r122 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-chip", 201);
    i0.ɵɵlistener("removed", function PrintPetitionLibraryComponent_div_9_mat_chip_41_Template_mat_chip_removed_0_listener() { i0.ɵɵrestoreView(_r122); const forms_r119 = ctx.$implicit; const ctx_r121 = i0.ɵɵnextContext(2); return ctx_r121.remove(forms_r119.pbSupportDocumentId); });
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, PrintPetitionLibraryComponent_div_9_mat_chip_41_mat_icon_2_Template, 2, 0, "mat-icon", 202);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const forms_r119 = ctx.$implicit;
    const ctx_r108 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("selectable", ctx_r108.selectable)("removable", ctx_r108.removable);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", forms_r119.formType, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r108.removable);
} }
function PrintPetitionLibraryComponent_div_9_div_42_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 199);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r123 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r123.getGlobalErrorMessages("REQUIRED"), " ");
} }
function PrintPetitionLibraryComponent_div_9_div_42_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 204);
    i0.ɵɵtemplate(1, PrintPetitionLibraryComponent_div_9_div_42_span_1_Template, 2, 1, "span", 198);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r109 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r109.definedtemplate.get("addForms").errors == null ? null : ctx_r109.definedtemplate.get("addForms").errors.required);
} }
const _c2 = function () { return { width: "80vw" }; };
function PrintPetitionLibraryComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r125 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p-dialog", 130);
    i0.ɵɵlistener("visibleChange", function PrintPetitionLibraryComponent_div_9_Template_p_dialog_visibleChange_1_listener($event) { i0.ɵɵrestoreView(_r125); const ctx_r124 = i0.ɵɵnextContext(); return ctx_r124.displayDialog = $event; });
    i0.ɵɵelementStart(2, "div", 131);
    i0.ɵɵelementStart(3, "form", 46);
    i0.ɵɵlistener("ngSubmit", function PrintPetitionLibraryComponent_div_9_Template_form_ngSubmit_3_listener() { i0.ɵɵrestoreView(_r125); const ctx_r126 = i0.ɵɵnextContext(); return ctx_r126.onSubmit(); });
    i0.ɵɵelementStart(4, "div", 132);
    i0.ɵɵelementStart(5, "div", 133);
    i0.ɵɵelement(6, "button", 134);
    i0.ɵɵelementStart(7, "div", 44);
    i0.ɵɵelementStart(8, "p", 42);
    i0.ɵɵtext(9, "Email Template");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "p-dropdown", 135);
    i0.ɵɵlistener("onChange", function PrintPetitionLibraryComponent_div_9_Template_p_dropdown_onChange_10_listener($event) { i0.ɵɵrestoreView(_r125); const ctx_r127 = i0.ɵɵnextContext(); return ctx_r127.onTemplateChange($event.value); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 136);
    i0.ɵɵelementStart(12, "div", 43);
    i0.ɵɵelementStart(13, "label", 137);
    i0.ɵɵtext(14, "From");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "p-chips", 138);
    i0.ɵɵtemplate(16, PrintPetitionLibraryComponent_div_9_div_16_Template, 3, 2, "div", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 43);
    i0.ɵɵelementStart(18, "label", 139);
    i0.ɵɵtext(19, "To");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(20, "p-chips", 140);
    i0.ɵɵtemplate(21, PrintPetitionLibraryComponent_div_9_div_21_Template, 3, 2, "div", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 43);
    i0.ɵɵelementStart(23, "label", 141);
    i0.ɵɵtext(24, "Cc");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(25, "p-chips", 142);
    i0.ɵɵtemplate(26, PrintPetitionLibraryComponent_div_9_div_26_Template, 2, 1, "div", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 43);
    i0.ɵɵelementStart(28, "label", 143);
    i0.ɵɵtext(29, "Subject");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(30, "br");
    i0.ɵɵelement(31, "input", 144);
    i0.ɵɵtemplate(32, PrintPetitionLibraryComponent_div_9_div_32_Template, 2, 1, "div", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "div", 145);
    i0.ɵɵelementStart(34, "label", 146);
    i0.ɵɵtext(35, "Add Forms");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "mat-form-field");
    i0.ɵɵelementStart(37, "mat-select", 147);
    i0.ɵɵlistener("selectionChange", function PrintPetitionLibraryComponent_div_9_Template_mat_select_selectionChange_37_listener($event) { i0.ɵɵrestoreView(_r125); const ctx_r128 = i0.ɵɵnextContext(); return ctx_r128.onChangeForms($event); });
    i0.ɵɵtemplate(38, PrintPetitionLibraryComponent_div_9_mat_option_38_Template, 2, 2, "mat-option", 148);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "mat-chip-list", 149, 150);
    i0.ɵɵtemplate(41, PrintPetitionLibraryComponent_div_9_mat_chip_41_Template, 3, 4, "mat-chip", 151);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(42, PrintPetitionLibraryComponent_div_9_div_42_Template, 2, 1, "div", 152);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(43, "div", 43);
    i0.ɵɵelementStart(44, "kendo-editor", 153, 154);
    i0.ɵɵlistener("valueChange", function PrintPetitionLibraryComponent_div_9_Template_kendo_editor_valueChange_44_listener($event) { i0.ɵɵrestoreView(_r125); const ctx_r129 = i0.ɵɵnextContext(); return ctx_r129.createtemplatelibraryheaderValueChange($event); });
    i0.ɵɵelementStart(46, "kendo-toolbar");
    i0.ɵɵelementStart(47, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(48, "kendo-toolbar-button", 155);
    i0.ɵɵelement(49, "kendo-toolbar-button", 156);
    i0.ɵɵelement(50, "kendo-toolbar-button", 157);
    i0.ɵɵelement(51, "kendo-toolbar-button", 158);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(52, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(53, "kendo-toolbar-button", 159);
    i0.ɵɵelement(54, "kendo-toolbar-button", 160);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(55, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(56, "kendo-toolbar-button", 161);
    i0.ɵɵelement(57, "kendo-toolbar-button", 162);
    i0.ɵɵelement(58, "kendo-toolbar-button", 163);
    i0.ɵɵelement(59, "kendo-toolbar-button", 164);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(60, "kendo-toolbar-dropdownlist", 165);
    i0.ɵɵelement(61, "kendo-toolbar-dropdownlist", 166);
    i0.ɵɵelement(62, "kendo-toolbar-dropdownlist", 167);
    i0.ɵɵelement(63, "kendo-toolbar-colorpicker", 168);
    i0.ɵɵelement(64, "kendo-toolbar-colorpicker", 169);
    i0.ɵɵelementStart(65, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(66, "kendo-toolbar-button", 170);
    i0.ɵɵelement(67, "kendo-toolbar-button", 171);
    i0.ɵɵelement(68, "kendo-toolbar-button", 172);
    i0.ɵɵelement(69, "kendo-toolbar-button", 173);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(70, "kendo-toolbar-button", 174);
    i0.ɵɵelement(71, "kendo-toolbar-button", 175);
    i0.ɵɵelementStart(72, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(73, "kendo-toolbar-button", 176);
    i0.ɵɵelement(74, "kendo-toolbar-button", 177);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(75, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(76, "kendo-toolbar-button", 178);
    i0.ɵɵelement(77, "kendo-toolbar-button", 179);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(78, "kendo-toolbar-button", 180);
    i0.ɵɵelement(79, "kendo-toolbar-button", 181);
    i0.ɵɵelement(80, "kendo-toolbar-button", 182);
    i0.ɵɵelement(81, "kendo-editor-insert-table-button");
    i0.ɵɵelementStart(82, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(83, "kendo-toolbar-button", 183);
    i0.ɵɵelement(84, "kendo-toolbar-button", 184);
    i0.ɵɵelement(85, "kendo-toolbar-button", 185);
    i0.ɵɵelement(86, "kendo-toolbar-button", 186);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(87, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(88, "kendo-toolbar-button", 187);
    i0.ɵɵelement(89, "kendo-toolbar-button", 188);
    i0.ɵɵelement(90, "kendo-toolbar-button", 189);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(91, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(92, "kendo-toolbar-button", 190);
    i0.ɵɵelement(93, "kendo-toolbar-button", 191);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(94, "kendo-toolbar-button", 192);
    i0.ɵɵelementStart(95, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(96, "kendo-toolbar-button", 193);
    i0.ɵɵelementStart(97, "kendo-toolbar-button", 194);
    i0.ɵɵlistener("click", function PrintPetitionLibraryComponent_div_9_Template_kendo_toolbar_button_click_97_listener() { i0.ɵɵrestoreView(_r125); const ctx_r130 = i0.ɵɵnextContext(); return ctx_r130.createtemplatelibraryheaderimageuploaddialog(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(98, "app-upload-image-dialog", 195, 196);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(100, "div", 197);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r110 = i0.ɵɵreference(45);
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(19, _c2));
    i0.ɵɵproperty("visible", ctx_r7.displayDialog)("draggable", false)("resizable", false)("modal", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formGroup", ctx_r7.definedtemplate);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", !ctx_r7.definedtemplate.valid);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r7.templateList);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("disabled", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.definedtemplate.get("fromEmailids").touched && ctx_r7.definedtemplate.get("fromEmailids").invalid);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r7.definedtemplate.get("toEmailids").touched && ctx_r7.definedtemplate.get("toEmailids").invalid);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r7.definedtemplate.get("ccEmailids").touched && ctx_r7.definedtemplate.get("ccEmailids").invalid);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readonly", false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.definedtemplate.get("subject").touched && ctx_r7.definedtemplate.get("subject").invalid);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r7.formsList);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r7.displayForms);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.definedtemplate.get("addForms").touched && ctx_r7.definedtemplate.get("addForms").invalid);
    i0.ɵɵadvance(56);
    i0.ɵɵproperty("editor", _r110);
} }
const _c3 = function () { return { width: "30vw" }; };
function PrintPetitionLibraryComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r132 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p-dialog", 205);
    i0.ɵɵlistener("visibleChange", function PrintPetitionLibraryComponent_div_10_Template_p_dialog_visibleChange_1_listener($event) { i0.ɵɵrestoreView(_r132); const ctx_r131 = i0.ɵɵnextContext(); return ctx_r131.placeholderErrorDialog = $event; });
    i0.ɵɵelement(2, "hr");
    i0.ɵɵelementStart(3, "div", 206);
    i0.ɵɵelementStart(4, "div", 207);
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6, "Your email contains unpopulated placeholder. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "div", 208);
    i0.ɵɵelementStart(8, "div", 207);
    i0.ɵɵelementStart(9, "p");
    i0.ɵɵtext(10, "It is highlighted in Red.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "p");
    i0.ɵɵelementStart(12, "b");
    i0.ɵɵtext(13, "Please replace or remove before sending.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "hr");
    i0.ɵɵelementStart(15, "p-footer");
    i0.ɵɵelementStart(16, "button", 209);
    i0.ɵɵlistener("click", function PrintPetitionLibraryComponent_div_10_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r132); const ctx_r133 = i0.ɵɵnextContext(); return ctx_r133.placeholderErrorDialog = false; });
    i0.ɵɵtext(17, "Ok");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(6, _c3));
    i0.ɵɵproperty("visible", ctx_r8.placeholderErrorDialog)("draggable", false)("resizable", false)("modal", true);
} }
class PrintPetitionLibraryComponent extends BasePrintPetitionLibraryService {
    constructor(store, apiService, toastr, stepStatusUpdatePayloadCostructionService, dialog, fb) {
        super(store, apiService, toastr, stepStatusUpdatePayloadCostructionService, dialog, fb);
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostructionService = stepStatusUpdatePayloadCostructionService;
        this.dialog = dialog;
        this.fb = fb;
        this.onDialogClose = new EventEmitter();
    }
    ngOnInit() {
        var _a;
        sessionStorage.setItem('signatureUpload', 'true');
        this.envPath = environment.docs;
        this.isSimplifyH1b = this.simplifyH1b;
        this.inputData = this.primaryData;
        super.loadInit();
        if ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.isBeneficiaryInitiate) {
            this.sectionCode = 'BEN_PRINT_PETITION';
        }
        else {
            this.sectionCode = 'PRINT_PETITION';
        }
    }
    handleClose() {
        this.onDialogClose.emit();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        sessionStorage.removeItem('signatureUpload');
    }
}
PrintPetitionLibraryComponent.ɵfac = function PrintPetitionLibraryComponent_Factory(t) { return new (t || PrintPetitionLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.APIPrintPetition), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i5.MatDialog), i0.ɵɵdirectiveInject(i6.FormBuilder)); };
PrintPetitionLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: PrintPetitionLibraryComponent, selectors: [["print-petition-library"]], inputs: { primaryData: "primaryData", isWizard: "isWizard", simplifyH1b: "simplifyH1b" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 11, vars: 9, consts: [[1, "fluid-container"], [4, "ngIf"], ["class", "row pt-1 pl-3 d-flex align-items-center", 4, "ngIf"], ["class", "row", 4, "ngIf"], ["class", "header-divider", 4, "ngIf"], [1, "main-body", "footer-adjust"], [3, "inputDetails", "primaryData", "sectionCode", 4, "ngIf"], [3, "ngClass", 4, "ngIf"], ["class", "row col-md-12", 4, "ngIf"], ["class", "row pt-4 d-flex align-items-center", 4, "ngIf"], [1, "row", "pt-4", "d-flex", "align-items-center"], ["class", "col-md-9 step-title p-0", 4, "ngIf"], [1, "col-md-2", "editBtn"], ["type", "EDIT", 3, "visaType", "stepDetails", "isViewMode", "isCaseRequest", 4, "ngIf"], [1, "col-md-1", "pr-0", "pl-2", "d-flex", "justify-content-end"], [3, "configData"], [1, "close-icon", "pi", "pi-times", 3, "click"], [1, "col-md-9", "step-title", "p-0"], [1, "page-header"], ["type", "EDIT", 3, "visaType", "stepDetails", "isViewMode", "isCaseRequest"], [1, "row", "pt-1", "pl-3", "d-flex", "align-items-center"], [1, "col-md-8", "step-title", "p-0"], [1, "page-header", "pl-0", "headerPortion"], [1, "col-md-4", "editBtn", "headerSubPortion", "px-0"], [1, "col-8", "px-0", "firstPortion"], ["type", "EDIT", "class", "float-right", 3, "visaType", "stepDetails", "isViewMode", "isCaseRequest", 4, "ngIf"], [1, "col-4", "pr-0", "pl-2", "secondPortion"], ["type", "EDIT", 1, "float-right", 3, "visaType", "stepDetails", "isViewMode", "isCaseRequest"], [1, "row"], [1, "col-md-12", "p-0"], [3, "visaType", "stepDetails", "isViewMode", "isCaseRequest", "updateStatus"], [1, "header-divider"], [3, "inputDetails", "primaryData", "sectionCode"], [3, "ngClass"], ["styleClass", "review-petition-tab-view"], ["header", "Signatures"], [1, "petition-analysis-holder"], [1, "row", "mb-3"], [1, "col-12", "pl-0", "pr-0"], [1, "col-md-12", "p-4", "signatureContent"], [1, "row", "signatureType"], [1, "col-12", "mb-2"], [1, "mb-0"], [1, "col-12"], [1, "emailTemplate"], ["placeholder", "Select Type", "optionLabel", "signatureType", "optionValue", "id", "name", "signatureType", 1, "w-100", 3, "options", "ngModel", "ngModelChange", "onChange"], [3, "formGroup", "ngSubmit"], [1, "col-12", "mt-3", "p-0"], [1, "row", "selectFormPortion"], [1, "col-6", "subHeadFirst", "pt-3", "pb-3"], ["class", "pl-0", 4, "ngIf"], [1, "col-6", "subHeadSecond", "pt-3", "pb-3"], ["pButton", "", "pRipple", "", "type", "button", "label", "RESEND EMAIL", "icon", "pi pi-envelope", "iconPos", "left", "class", "p-button-raised p-button-text p-2 ml-3", 3, "disabled", "click", 4, "ngIf"], ["pButton", "", "pRipple", "", "type", "button", "label", "EMAIL", "icon", "pi pi-envelope", "iconPos", "right", "class", "p-button-raised p-button-text p-2 ml-3", 3, "disabled", "click", 4, "ngIf"], ["pButton", "", "pRipple", "", "type", "button", "label", "GENERATE", "iconPos", "right", "class", "p-button-raised p-button-text p-2 ml-3", 3, "disabled", "click", 4, "ngIf"], ["id", "documentListForm", 1, "col-12", "p-0"], [1, "review-accordion"], [1, "mat-elevation-z8", "im-card-no-border-table", "im-card-table-noborder-spacing", "table"], ["class", "im-input mw-100", "type", "checkbox", "name", "list_name", 3, "ngModel", "ngModelChange", "change", 4, "ngIf"], ["class", "col-12 mt-3 p-0 noData", 4, "ngIf"], ["header", "Generate & Print Petition"], ["class", "row pb-2", 4, "ngIf"], ["class", "row col-10 mb-3 petitionPortion p-2", 4, "ngIf"], ["class", "row pt-3 border-top", 4, "ngIf"], ["class", "col-3 checkBoxPortion pr-0", 4, "ngFor", "ngForOf"], [1, "col-12", "requestForSignature"], ["pButton", "", "pRipple", "", "type", "submit", "label", "Request for Signature Image", "icon", "pi pi-info-circle", "iconPos", "right", "pTooltip", "Notification will be triggered to upload/provide a digital signature in the profile section", 1, "p-button-raised", "p-button-text"], [1, "col-3", "checkBoxPortion", "pr-0"], [1, "customWrapper"], ["type", "checkbox", 3, "formControlName", "change"], [3, "for"], ["class", "pi pi-info-circle", "pTooltip", "Signature is not available in the profile section.", 4, "ngIf"], ["pTooltip", "Signature is not available in the profile section.", 1, "pi", "pi-info-circle"], [1, "timeLinePortion"], [1, "timeline"], [1, "timeline-item"], [1, "circle"], [1, "col-11", "p-0"], [1, "col-6", "p-0"], [1, "col-12", "signedPortion", 3, "formGroup"], [1, "col-12", "warningMessage"], [1, "pi", "pi-exclamation-triangle"], [1, "col-12", "p-0"], [1, "row", "signedForms"], [1, "col-md-12", "signatureHead"], [1, "p-field-radiobutton", "mb-0"], ["name", "returnForm", "value", "type3", "inputId", "type3", 3, "ngModel", "ngModelChange", "onClick"], [1, "p-field-radiobutton", "ml-2", "mb-0"], ["name", "returnForm", "value", "type4", "inputId", "type4", 3, "ngModel", "ngModelChange", "onClick"], [1, "pl-0"], ["pButton", "", "pRipple", "", "type", "button", "label", "RESEND EMAIL", "icon", "pi pi-envelope", "iconPos", "left", 1, "p-button-raised", "p-button-text", "p-2", "ml-3", 3, "disabled", "click"], ["pButton", "", "pRipple", "", "type", "button", "label", "EMAIL", "icon", "pi pi-envelope", "iconPos", "right", 1, "p-button-raised", "p-button-text", "p-2", "ml-3", 3, "disabled", "click"], ["pButton", "", "pRipple", "", "type", "button", "label", "GENERATE", "iconPos", "right", 1, "p-button-raised", "p-button-text", "p-2", "ml-3", 3, "disabled", "click"], ["type", "checkbox", "name", "list_name", 1, "im-input", "mw-100", 3, "ngModel", "ngModelChange", "change"], [4, "ngFor", "ngForOf"], ["type", "checkbox", "name", "list_name", 3, "ngModel", "value", "ngModelChange", "change"], [3, "successInfo", "warnInfo", 4, "ngIf"], [1, "iconPortion"], ["type", "button", "label", "", "icon", "pi pi-cog", "iconPos", "right", 1, "menu-button", 3, "click"], ["id", "uploadSign", 1, "menu-container", "customToggle", 3, "hidden"], [3, "click", 4, "ngIf"], [3, "click"], ["mode", "basic", "chooseLabel", "Upload Form", "chooseIcon", "", "customUpload", "true", "name", "demo[]", 3, "accept", "auto", "uploadHandler"], ["fubauto", ""], [1, "col-12", "mt-3", "p-0", "noData"], [1, "pl-2"], [1, "row", "pb-2"], [1, "col-12", "pl-0"], [1, "mt-3"], [1, "row", "col-10", "mb-3", "petitionPortion", "p-2"], [1, "col-6", "p-0", "fullPetition"], ["for", ""], ["class", "col-3 customGenerated p-0", 4, "ngIf"], [1, "col-3", "customActions", "p-0"], ["class", "pi pi-eye", "pTooltip", "View", 3, "click", 4, "ngIf"], ["class", "fileDownload", 4, "ngIf"], ["pTooltip", "Generate Petition", 1, "pi", "pi-file-plus", 3, "ngClass", "click"], [1, "col-3", "customGenerated", "p-0"], [1, "mb-0", "generated"], [1, "mb-0", "generatedDate"], [1, "mb-0", "notGenerated"], ["pTooltip", "View", 1, "pi", "pi-eye", 3, "click"], [1, "fileDownload"], [3, "fileName", "Path"], [1, "row", "pt-3", "border-top"], [1, "col-md-6"], [1, "col-md-6", "completeStep"], ["class", "d-flex col-12 justify-content-end", 3, "visaType", "stepDetails", "type", "showPreviousStepBtn", "showNextStepBtn", 4, "ngIf"], [1, "d-flex", "col-12", "justify-content-end", 3, "visaType", "stepDetails", "type", "showPreviousStepBtn", "showNextStepBtn"], [1, "row", "col-md-12"], ["header", "New Email", "modal", "true", "appendTo", "body", 3, "visible", "draggable", "resizable", "modal", "visibleChange"], ["mat-dialog-content", "", "id", "emailSendContent", 1, "message"], [1, "row", "newEmailHeaderMain"], [1, "col-12", "newEmailHeaderSub"], ["pButton", "", "pRipple", "", "type", "submit", "label", "SEND", "icon", "pi pi-send", "iconPos", "left", 1, "p-button-text", "p-1", 3, "disabled"], ["inputId", "", "placeholder", "Select Template", "optionLabel", "templateName", "optionValue", "id", "name", "templateName", "formControlName", "templatename", 1, "w-100", 3, "options", "onChange"], [1, "row", "newEmailContent"], ["for", "fromEmail", 1, "required"], ["id", "fromEmail", "formControlName", "fromEmailids", "separator", ",", "placeholder", "Enter emails", 3, "disabled"], ["for", "toEmail", 1, "required"], ["id", "toEmail", "formControlName", "toEmailids", "separator", ",", "placeholder", "Enter emails"], ["for", "ccEmail"], ["id", "ccEmail", "formControlName", "ccEmailids", "separator", ",", "placeholder", "Enter emails"], ["for", "subject", 1, "required"], ["type", "text", "formControlName", "subject", 3, "readonly"], [1, "col-12", "mb-4"], [1, "w-100", "mb-0", "required"], ["formControlName", "addForms", "multiple", "", 3, "selectionChange"], [3, "value", 4, "ngFor", "ngForOf"], [1, "clsFileUploadMatChipList"], ["chipList", ""], [3, "selectable", "removable", "removed", 4, "ngFor", "ngForOf"], ["class", "mt-2", 4, "ngIf"], ["name", "createtemplatelibraryheaderTextContent", "formControlName", "emailbody", 2, "height", "400px", 3, "valueChange"], ["createtemplatelibraryheaderkendoeditor", ""], ["kendoEditorBoldButton", ""], ["kendoEditorItalicButton", ""], ["kendoEditorUnderlineButton", ""], ["kendoEditorStrikethroughButton", ""], ["kendoEditorSubscriptButton", ""], ["kendoEditorSuperscriptButton", ""], ["kendoEditorAlignLeftButton", ""], ["kendoEditorAlignCenterButton", ""], ["kendoEditorAlignRightButton", ""], ["kendoEditorAlignJustifyButton", ""], ["kendoEditorFormat", ""], ["kendoEditorFontSize", ""], ["kendoEditorFontFamily", ""], ["kendoEditorForeColor", ""], ["kendoEditorBackColor", "", "view", "gradient"], ["kendoEditorInsertUnorderedListButton", ""], ["kendoEditorInsertOrderedListButton", ""], ["kendoEditorIndentButton", ""], ["kendoEditorOutdentButton", ""], ["kendoEditorBlockquoteButton", ""], ["kendoEditorSelectAllButton", ""], ["kendoEditorUndoButton", ""], ["kendoEditorRedoButton", ""], ["kendoEditorCreateLinkButton", ""], ["kendoEditorUnlinkButton", ""], ["kendoEditorInsertFileButton", ""], ["kendoEditorViewSourceButton", ""], ["kendoEditorCleanFormattingButton", ""], ["kendoEditorAddColumnBeforeButton", ""], ["kendoEditorAddColumnAfterButton", ""], ["kendoEditorAddRowBeforeButton", ""], ["kendoEditorAddRowAfterButton", ""], ["kendoEditorDeleteColumnButton", ""], ["kendoEditorDeleteRowButton", ""], ["kendoEditorDeleteTableButton", ""], ["kendoEditorMergeCellsButton", ""], ["kendoEditorSplitCellButton", ""], ["kendoEditorPrintButton", ""], ["kendoEditorInsertImageButton", ""], ["title", "Upload\u2019s Image at cursor point", "text", "Upload Image", 3, "click"], [3, "editor"], ["createtemplatelibraryheaderupload", ""], ["mat-dialog-actions", "", 1, "float-left"], ["class", "invalid-message", 4, "ngIf"], [1, "invalid-message"], [3, "value"], [3, "selectable", "removable", "removed"], ["matChipRemove", "", 4, "ngIf"], ["matChipRemove", ""], [1, "mt-2"], ["header", "Alert", "modal", "true", "appendTo", "body", 3, "visible", "draggable", "resizable", "modal", "visibleChange"], [1, "row", "mt-2"], [1, "w-100"], [1, "clearfix"], [1, "btn", "btn-secondary", 3, "click"]], template: function PrintPetitionLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, PrintPetitionLibraryComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        i0.ɵɵtemplate(2, PrintPetitionLibraryComponent_div_2_Template, 14, 4, "div", 2);
        i0.ɵɵtemplate(3, PrintPetitionLibraryComponent_div_3_Template, 3, 4, "div", 3);
        i0.ɵɵtemplate(4, PrintPetitionLibraryComponent_p_divider_4_Template, 1, 0, "p-divider", 4);
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵtemplate(6, PrintPetitionLibraryComponent_lib_last_update_library_6_Template, 1, 3, "lib-last-update-library", 6);
        i0.ɵɵtemplate(7, PrintPetitionLibraryComponent_div_7_Template, 55, 17, "div", 7);
        i0.ɵɵtemplate(8, PrintPetitionLibraryComponent_div_8_Template, 1, 0, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, PrintPetitionLibraryComponent_div_9_Template, 101, 20, "div", 1);
        i0.ɵɵtemplate(10, PrintPetitionLibraryComponent_div_10_Template, 18, 7, "div", 1);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? true : false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizard || ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayDialog);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.placeholderErrorDialog);
    } }, directives: [i7.NgIf, i8.MaximizeDialogLibraryComponent, i9.StepStatusUpdateComponentLibraryComponent, i10.AssigningTaskLibraryComponent, i11.Divider, i12.LastUpdateLibraryComponent, i7.NgClass, i13.TabView, i13.TabPanel, i14.Dropdown, i6.NgControlStatus, i6.NgModel, i6.ɵangular_packages_forms_forms_ba, i6.NgControlStatusGroup, i6.FormGroupDirective, i7.NgForOf, i15.ButtonDirective, i16.Tooltip, i6.CheckboxControlValueAccessor, i6.FormControlName, i17.RadioButton, i15.Button, i18.FileUpload, i19.FileDownloadLibraryComponent, i20.Dialog, i21.Chips, i6.DefaultValueAccessor, i22.MatFormField, i23.MatSelect, i24.MatChipList, i25.EditorComponent, i26.ToolBarComponent, i26.ToolBarButtonGroupComponent, i26.ToolBarButtonComponent, i25.EditorBoldButtonDirective, i25.EditorItalicButtonDirective, i25.EditorUnderlineButtonDirective, i25.EditorStrikethroughButtonDirective, i25.EditorSubscriptButtonDirective, i25.EditorSuperscriptButtonDirective, i25.EditorAlignLeftButtonDirective, i25.EditorAlignCenterButtonDirective, i25.EditorAlignRightButtonDirective, i25.EditorAlignJustifyButtonDirective, i25.EditorFormatComponent, i25.EditorFontSizeComponent, i25.EditorFontFamilyComponent, i25.EditorColorPickerComponent, i25.EditorForeColorDirective, i25.EditorBackColorDirective, i25.EditorInsertUnorderedListButtonDirective, i25.EditorInsertOrderedListButtonDirective, i25.EditorIndentButtonDirective, i25.EditorOutdentButtonDirective, i25.EditorBlockquoteDirective, i25.EditorSelectAllButtonDirective, i25.EditorUndoButtonDirective, i25.EditorRedoButtonDirective, i25.EditorCreateLinkButtonDirective, i25.EditorUnlinkButtonDirective, i25.EditorInsertFileButtonDirective, i25.EditorViewSourceButtonDirective, i25.EditorCleanFormattingButtonDirective, i25.EditorInsertTableButtonComponent, i25.EditorAddColumnBeforeButtonDirective, i25.EditorAddColumnAfterButtonDirective, i25.EditorAddRowBeforeButtonDirective, i25.EditorAddRowAfterButtonDirective, i25.EditorDeleteColumnButtonDirective, i25.EditorDeleteRowButtonDirective, i25.EditorDeleteTableButtonDirective, i25.EditorMergeCellsButtonDirective, i25.EditorSplitCellButtonDirective, i25.EditorPrintDirective, i25.EditorInsertImageButtonDirective, i27.UploadImageDialogComponent, i28.MatOption, i24.MatChip, i29.MatIcon, i24.MatChipRemove, i30.Footer], styles: [".mark-btn[_ngcontent-%COMP%]{background-color:#fff;color:#a2a2a2;font-size:14px;text-transform:uppercase;border:1px solid #a2a2a2;border-radius:8px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:8px;border-radius:20px;font-weight:700;cursor:pointer}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 21px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 13px/22px Source Sans Pro}.main-body[_ngcontent-%COMP%]{height:calc(80vh - 216px);width:100%;overflow:auto}.headerPortion[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{color:#002e83;font-weight:600}.heading-big-wizard[_ngcontent-%COMP%]{color:#3498db;font-weight:700;font-size:1.75rem;margin-bottom:15px}.signatureHead[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;align-items:center}.signatureHead[_ngcontent-%COMP%]   div.p-field-radiobutton[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin-bottom:0!important}.avalible[_ngcontent-%COMP%]{color:#30c730}.notAvalible[_ngcontent-%COMP%]{color:#f0a824}.signatureContent[_ngcontent-%COMP%]{background-color:#f6f6f6}.signedForms[_ngcontent-%COMP%]{border-top:1px dashed #ccc;margin-top:10px;padding-top:15px}.requestForSignature[_ngcontent-%COMP%]{padding-left:26.5%}.requestForSignature[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{border:1px solid #2196f3;font-size:14px}.warningMessage[_ngcontent-%COMP%]{display:flex;-moz-column-gap:5px;column-gap:5px}.warningMessage[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{font-size:14px!important;font-style:italic;color:#797676;text-align:justify;margin-bottom:0}.timeline[_ngcontent-%COMP%]{position:relative;padding:0;list-style:none;top:-65px}.timeline[_ngcontent-%COMP%]:before{content:\"\";position:absolute;top:0;bottom:0;left:50%;width:2px;background:linear-gradient(180deg,transparent,#ccc,transparent);border-left:2px dashed #666}.timeline-item[_ngcontent-%COMP%]{position:relative;margin:66px 0;display:flex;justify-content:center;text-align:center}.circle[_ngcontent-%COMP%]{width:20px;height:20px;background-color:#3e3f5e;color:#fff;border-radius:50%;line-height:20px;font-weight:300;text-align:center}.timeLinePortion[_ngcontent-%COMP%]{height:110px}#documentListForm[_ngcontent-%COMP%]{min-height:600px;max-height:600px;overflow-y:auto}#documentListForm[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{font-size:14px}#documentListForm[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{padding:15px!important}#documentListForm[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{height:15px}.selectFormPortion[_ngcontent-%COMP%]   .subHeadFirst[_ngcontent-%COMP%]{background-color:#f6f6f6;display:flex;justify-content:flex-start;align-items:center}.selectFormPortion[_ngcontent-%COMP%]   .subHeadSecond[_ngcontent-%COMP%]{background-color:#f6f6f6;display:flex;justify-content:flex-end;align-items:center}.selectFormPortion[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{font-size:16px;padding-left:10px;font-weight:600;margin-bottom:0}#emailSendContent[_ngcontent-%COMP%]   .newEmailHeaderMain[_ngcontent-%COMP%]{border-top:1px solid #ccc;padding-top:15px}#emailSendContent[_ngcontent-%COMP%]   .newEmailHeaderMain[_ngcontent-%COMP%]   .newEmailHeaderSub[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;box-shadow:5px 5px 10px #d7d3d3;padding:10px 15px}#emailSendContent[_ngcontent-%COMP%]   .newEmailContent[_ngcontent-%COMP%]{box-shadow:5px 5px 10px #d7d3d3;padding:10px 15px}#courierContent[_ngcontent-%COMP%]{padding-top:15px;border-top:1px solid #ccc}#courierContent[_ngcontent-%COMP%]   .signatureHead[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;align-items:center;padding-bottom:40px;border-bottom:1px solid #ccc}#courierContent[_ngcontent-%COMP%]   .signatureHead[_ngcontent-%COMP%]   div.p-field-radiobutton[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin-bottom:0!important}#courierContent[_ngcontent-%COMP%]   .footerPortion[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center}.generatePetitionFirst[_ngcontent-%COMP%]{background-color:#eee;padding:15px;display:flex;justify-content:flex-start;align-items:center}.generatePetitionFirst[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{font-weight:600}.generatePetitionView[_ngcontent-%COMP%]{background-color:#eee;padding:15px}.generateContent[_ngcontent-%COMP%]{background-color:#eee}.notgenerateContent[_ngcontent-%COMP%]{background-color:#eee;display:flex;align-items:center}.actionPortion[_ngcontent-%COMP%]{display:flex;justify-content:space-evenly;align-items:center;cursor:pointer}.generated[_ngcontent-%COMP%]{color:#13b613}.notGenerated[_ngcontent-%COMP%]{color:#e89d13}.generatedDate[_ngcontent-%COMP%]{color:#a29f9f}.fileDownload[_ngcontent-%COMP%]{position:relative;top:3px}.customWrapper[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;align-items:center}.customWrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:20px;height:20px;margin:0 6px 0 0}.customWrapper[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin:0}.signedPortion[_ngcontent-%COMP%]{display:flex;padding:0}.emailTemplate[_ngcontent-%COMP%]{width:30%}.notAllowed[_ngcontent-%COMP%]{pointer-events:none;opacity:.7}.notAllowedBox[_ngcontent-%COMP%]{opacity:.5;cursor:not-allowed}.iconPortion[_ngcontent-%COMP%]{cursor:pointer;font-size:8px;color:#595757}.notReceived[_ngcontent-%COMP%]{color:#f5a209}.received[_ngcontent-%COMP%]{color:#0f970f}.customGenerated[_ngcontent-%COMP%]{font-size:14px}.customActions[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;gap:10px;align-items:center}.customActions[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{cursor:pointer}.fullPetition[_ngcontent-%COMP%]{display:flex;align-items:center}.fullPetition[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin-bottom:0;color:#000}.actionItems[_ngcontent-%COMP%]   .actionPortion[_ngcontent-%COMP%]{display:flex;align-items:center;padding-top:7px;justify-content:flex-start;gap:7px}.actionItems[_ngcontent-%COMP%]   .actionPortion[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{cursor:pointer}.signatureStatus[_ngcontent-%COMP%]{padding-left:5px}.noData[_ngcontent-%COMP%]{text-align:center}.emailTemplateMain[_ngcontent-%COMP%]{border-bottom:1px dashed #ccc;padding-bottom:20px}.signatureType[_ngcontent-%COMP%]{padding-bottom:15px;border-bottom:1px dashed #ccc;margin-bottom:15px}.customToggle[_ngcontent-%COMP%]{position:absolute;background:#fff;border:1px solid #cdc8c8;padding:5px;z-index:1000;right:10px;min-width:100px}.customToggle[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0;font-size:14px;cursor:pointer;font-weight:600;padding-bottom:5px}.successInfo[_ngcontent-%COMP%]{color:green}.warnInfo[_ngcontent-%COMP%]{color:orange}.petitionPortion[_ngcontent-%COMP%]{background-color:#eee}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PrintPetitionLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'print-petition-library',
                templateUrl: 'print-petition-library.component.html',
                styleUrls: ['print-petition-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.APIPrintPetition }, { type: i3.ToastrService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.MatDialog }, { type: i6.FormBuilder }]; }, { primaryData: [{
            type: Input
        }], isWizard: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }], simplifyH1b: [{
            type: Input
        }] }); })();

class PrintPetitionLibraryModule {
}
PrintPetitionLibraryModule.ɵfac = function PrintPetitionLibraryModule_Factory(t) { return new (t || PrintPetitionLibraryModule)(); };
PrintPetitionLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: PrintPetitionLibraryModule });
PrintPetitionLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BasePrintPetitionLibraryService, ConfirmationService], imports: [[
            ConfirmPopupModule,
            ToastModule,
            ButtonModule,
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            DateFormatModule,
            LastUpdateLibraryModule,
            ConfirmPopupModule,
            AssigningTaskLibraryModule,
            MaximizeDialogLibraryModule,
            MatCheckboxModule,
            MatListModule,
            CommonModule,
            ngfModule,
            FileUploadLibraryModule,
            ReactiveFormsModule,
            MatInputModule,
            EditorModule,
            EditorLibraryModule,
            FormsModule,
            MatFormFieldModule,
            MatSelectModule,
            MatChipsModule,
            MatIconModule,
            FileDownloadLibraryModule,
            MatTooltipModule,
            MatTableModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PrintPetitionLibraryModule, { declarations: [PrintPetitionLibraryComponent], imports: [ConfirmPopupModule,
        ToastModule,
        ButtonModule,
        PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        DateFormatModule,
        LastUpdateLibraryModule,
        ConfirmPopupModule,
        AssigningTaskLibraryModule,
        MaximizeDialogLibraryModule,
        MatCheckboxModule,
        MatListModule,
        CommonModule,
        ngfModule,
        FileUploadLibraryModule,
        ReactiveFormsModule,
        MatInputModule,
        EditorModule,
        EditorLibraryModule,
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatChipsModule,
        MatIconModule,
        FileDownloadLibraryModule,
        MatTooltipModule,
        MatTableModule], exports: [PrintPetitionLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PrintPetitionLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [PrintPetitionLibraryComponent],
                imports: [
                    ConfirmPopupModule,
                    ToastModule,
                    ButtonModule,
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    DateFormatModule,
                    LastUpdateLibraryModule,
                    ConfirmPopupModule,
                    AssigningTaskLibraryModule,
                    MaximizeDialogLibraryModule,
                    MatCheckboxModule,
                    MatListModule,
                    CommonModule,
                    ngfModule,
                    FileUploadLibraryModule,
                    ReactiveFormsModule,
                    MatInputModule,
                    EditorModule,
                    EditorLibraryModule,
                    FormsModule,
                    MatFormFieldModule,
                    MatSelectModule,
                    MatChipsModule,
                    MatIconModule,
                    FileDownloadLibraryModule,
                    MatTooltipModule,
                    MatTableModule,
                ],
                providers: [BasePrintPetitionLibraryService, ConfirmationService],
                exports: [PrintPetitionLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of print-petition-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PrintPetitionLibraryComponent, PrintPetitionLibraryModule, PrintPetitionLibraryService };
//# sourceMappingURL=print-petition-library.js.map
